import React from 'react'
import "./dashboard.css";
const SideBar = () => {
  return (
    <div className="sideBar">
          <div className="sideBarItem">
            <a href="/dashboard">view Jobs</a>
          </div>
          <div className="sideBarItem">
            <a href="/dashboard/create_job"> Create Job</a>
          </div>
          {/* <div className="sideBarItem">
            <a href="/dashboard/analytics"> Analytics</a>
          </div> */}
        </div>
  )
}

export default SideBar
